import './check-dependencies';
import './dfp-pixel';
import pkg from '../package.json';
import {
  CONFIG_NAMESPACE
} from './constants';
import app        from './application';
import Publicidad from './publicidad';
import {lookup} from './utils';

const {$} = window;
var _initialized = false;

_legacyInit();
$(document).ready(function() {
  const config = lookup(CONFIG_NAMESPACE);
  _init(config.media, config.options);
});

export const VERSION = pkg.version;

/* Private */

function _legacyInit() {
  window.Vocento            = window.Vocento || {};
  window.Vocento.Publicidad = function() {};
  window.Vocento.Publicidad.prototype.init = function(jQuery, configGDPMedio, configGDP) {
    _init(configGDPMedio, configGDP);
  };
  window.Vocento.Publicidad.prototype.printAds = function(datos, esJSON = true) {
    return Publicidad.printAds(datos, esJSON);
  };
  window.Vocento.Publicidad.prototype.getOasSitepage = function(...params) {
    return Publicidad.getOasSitepage(...params);
  };
  window.Vocento.Publicidad.prototype.getSizesGoogle = function(...params) {
    return Publicidad.getSizesGoogle(...params);
  };
  window.Vocento.Publicidad.prototype.getValueUser = function(...params) {
    return Publicidad.getValueUser(...params);
  };
}

function _init(configGDPMedio, configGDP) {
  if (_initialized) {return;}

  if (!configGDPMedio || !configGDP) {throw Error('[Ads Manager] missing configuration');}

  _initialized = true;
  Publicidad.init(configGDPMedio, configGDP);
  _printAds();

  app.on('voonto:reload', (event, context$, configGDPMedioReload, configGDPReload) => {
    Publicidad.init(configGDPMedioReload, configGDPReload, context$);
    _printAds(context$);
  });
  app.on('vam:refresh', function (event, data) { // NOTE: refresh the ads position received on 'data' parameter
    var params = typeof data === 'string' ? JSON.parse(data) : data;
    Publicidad.printAds(params);
  });
}

function _printAds(context$) {
  $('[data-voc-vam]', context$).each(function () {
    Publicidad.printAds($(this));
  });
}



// WEBPACK FOOTER //
// ./src/index.js